import type { inferParserType } from "nuqs";
import { createSerializer, parseAsBoolean } from "nuqs";
import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { CompanyVendor } from "~/models/CompanyVendor";
import { generatePath } from "~/utils/generatePath";

export const companyVendorsIndexParsers = {
	only_assignable: parseAsBoolean.withDefault(true)
};

const serializeCompanyVendorsIndex = createSerializer(
	companyVendorsIndexParsers
);

export const useCompanyVendors = (
	query: inferParserType<typeof companyVendorsIndexParsers>
): SwrReturnType<CompanyVendor[]> => {
	const path = generatePath("/company_vendors");
	const searchParams = serializeCompanyVendorsIndex(query);
	const { data, mutate, error, isLoading } = useSWR<CompanyVendor[]>(
		`${path}${searchParams}`
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
